module.exports = __webpack_public_path__ + "img/overview_build1.3b423715.png";